export const CANNOT_GENERATE_REPORT = 'stores/CANNOT_GENERATE_REPORT';
